import React from 'react';
import { Select, FormControl } from '@material-ui/core';

interface TaskFilter {
  id: string,
  onOpen: () => void,
  onChange: (e: React.ChangeEvent<{
    name?: string;
    value: unknown;
  }>) => void,
  renderValue?: ((value: unknown) => React.ReactNode),
  children: React.ReactNode,
  value: string[]
}

export default function TaskFilter ({ onOpen, onChange, renderValue, children, value, ...props }: TaskFilter) {
  return (
    <FormControl>
      <Select
        multiple
        displayEmpty
        MenuProps={{ variant: 'menu' }}
        renderValue={renderValue}
        onChange={onChange}
        onOpen={onOpen}
        value={value}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
}
